// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N58n","title":"styles_title__3tOaq"};